import type { FireAnalyticsEvent } from '../../types';
import type {
	PreloadQueryVarsDiff,
	PreloadQueryVarsDiffReport,
} from '../../types/preload-query-vars-diff';

type PreloadQueryVarsDiffEventPayload = PreloadQueryVarsDiffReport & {
	search: PreloadQueryVarsDiff;
	rightPanel: PreloadQueryVarsDiff;
};

export const onPreloadQueryVarsDiff = ({
	match,
	mismatchCount,
	search,
	rightPanel,
	experimentLayers,
}: PreloadQueryVarsDiffEventPayload): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'preloadQueryVarsDiff',
	actionSubject: 'searchPage',
	attributes: {
		additionalAttributes: {
			experienceName: 'search-page',
			match,
			mismatchCount,
			search,
			rightPanel,
			// Temporary diagnostics field. Clean this up with FG `search_async_ssr`; for now keep
			// full SSR and SPA `experimentLayers` dumps here regardless of mismatch for diagnostics.
			experimentLayers,
		},
	},
});
